import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { colors, em, rem, rgba, spacing, typography, getResetByTag, utilityStyles } from './../../styles';
import StyledLoader from '../loader/loader.styles';
import StyledIconPath from '../loader/styles/loader.iconpath.styles';
var defaultStyles = /*#__PURE__*/css("align-items:center;appearance:none;border:", rem(1), " solid ", colors.transparent, ";color:", colors.navy_500, ";font-weight:", typography.typographyFontWeightBold, ";justify-content:center;position:relative;text-align:center;text-decoration:none;transition:background-color 0.2s ease,border-color 0.2s ease,box-shadow 0.2s ease,color 0.2s ease;vertical-align:top;white-space:normal;&:hover,&:focus,&:active{outline:0;text-decoration:none;}&::after{content:'';display:block;font-size:0;min-height:inherit;}" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "1lv1yo7",
  styles: "display:inline-flex"
} : {
  name: "5crygi-blockStyles",
  styles: "display:inline-flex;label:blockStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref3 = process.env.NODE_ENV === "production" ? {
  name: "7whenc",
  styles: "display:flex;width:100%"
} : {
  name: "qfxck6-blockStyles",
  styles: "display:flex;width:100%;label:blockStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var blockStyles = function blockStyles(_ref4) {
  var isBlock = _ref4.isBlock;
  if (isBlock) {
    return _ref3;
  }
  return _ref2;
};
var isCondensedStyles = function isCondensedStyles(_ref5) {
  var isCondensed = _ref5.isCondensed;
  return isCondensed && /*#__PURE__*/css("height:auto;min-width:0;padding:", rem(0, 8), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:isCondensedStyles;"));
};
var disabledStyles = function disabledStyles(_ref6) {
  var disabled = _ref6.disabled,
    hasIconOnly = _ref6.hasIconOnly,
    variant = _ref6.variant,
    isHollow = _ref6.isHollow,
    isPrimary = _ref6.isPrimary,
    isInverse = _ref6.isInverse;
  return disabled && /*#__PURE__*/css("&,&:hover,&:active,&:focus{background:", function () {
    if (hasIconOnly || isHollow) {
      return colors.transparent;
    }
    if (variant == 'muted' && !isPrimary) {
      return colors.coolGray_100;
    }
    if (variant == 'phony') {
      return colors.transparent;
    }
    return colors.coolGray_200;
  }(), ";border:", function () {
    if (variant !== 'phony' && !isHollow) {
      return "".concat(rem(1), " solid ").concat(colors.coolGray_500);
    }
  }(), ";box-shadow:none;color:", isHollow && isInverse ? colors.lightBlue_500 : colors.coolGray_500, ";cursor:not-allowed;font-weight:", isHollow && typography.typographyFontWeightSemiBold, ";opacity:", hasIconOnly ? 0.5 : 1, ";text-decoration:none;", variant === 'phony' && "padding: 0; min-height: 0; min-width: 0; vertical-align: baseline;", ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:disabledStyles;"));
};
var hasIconOnlyStyles = function hasIconOnlyStyles(_ref7) {
  var hasIconOnly = _ref7.hasIconOnly;
  return hasIconOnly && /*#__PURE__*/css("height:auto;min-height:0;min-width:0;padding:", rem(8), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:hasIconOnlyStyles;"));
};
var loaderStyles = function loaderStyles() {
  return /*#__PURE__*/css(StyledLoader, "{height:auto;left:0;position:absolute;top:50%;transform:translateY(-50%);width:100%;", StyledIconPath, "{stroke:currentColor;}&>svg{margin-right:0;}}" + (process.env.NODE_ENV === "production" ? "" : ";label:loaderStyles;"));
};
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1ch9yvl",
  styles: "border-radius:0"
} : {
  name: "hwbtve-shapeStyles",
  styles: "border-radius:0;label:shapeStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var shapeStyles = function shapeStyles(_ref8) {
  var shape = _ref8.shape;
  switch (shape) {
    case 'pill':
      return /*#__PURE__*/css("border-radius:", em(99), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:shapeStyles;"));
    case 'square':
      return _ref;
    default:
      return /*#__PURE__*/css("border-radius:", rem(8), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:shapeStyles;"));
  }
};
var sizeStyles = function sizeStyles(_ref9) {
  var isCondensed = _ref9.isCondensed,
    hasIconOnly = _ref9.hasIconOnly,
    size = _ref9.size;
  var sizes = {
    xs: {
      fontSize: typography.typographyBodySm,
      minHeight: spacing.spacingActionHeightXs - 2,
      minWidth: spacing.spacingActionWidthXs,
      padding: spacing.spacingActionPadXs
    },
    sm: {
      fontSize: typography.typographyBodySm,
      minHeight: spacing.spacingActionHeightSm - 2,
      minWidth: spacing.spacingActionWidthSm,
      padding: spacing.spacingActionPadSm
    },
    md: {
      fontSize: typography.typographyBodyMd,
      height: rem(44),
      // only 'md' has a set height
      minHeight: spacing.spacingActionHeightMd,
      minWidth: spacing.spacingActionWidthMd,
      padding: spacing.spacingActionPadMd
    },
    lg: {
      fontSize: typography.typographyBodyLg,
      minHeight: spacing.spacingActionHeightLg - 2,
      minWidth: spacing.spacingActionWidthLg,
      padding: spacing.spacingActionPadLg
    },
    xl: {
      fontSize: typography.typographyBodyLg,
      minHeight: spacing.spacingActionHeightXl - 2,
      minWidth: spacing.spacingActionWidthXl,
      padding: spacing.spacingActionPadLg
    }
  };
  var _ref10 = sizes[size] || sizes.md,
    fontSize = _ref10.fontSize,
    _ref10$height = _ref10.height,
    height = _ref10$height === void 0 ? 'auto' : _ref10$height,
    minHeight = _ref10.minHeight,
    minWidth = _ref10.minWidth,
    padding = _ref10.padding;
  return /*#__PURE__*/css("font-size:", fontSize, ";height:", height, ";", !hasIconOnly && /*#__PURE__*/css("min-height:", rem(minHeight), ";", !isCondensed && /*#__PURE__*/css("min-width:", rem(minWidth), ";padding:", padding, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:sizeStyles;")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:sizeStyles;")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:sizeStyles;"));
};
var svgStyles = function svgStyles(_ref11) {
  var hasIconOnly = _ref11.hasIconOnly;
  return /*#__PURE__*/css("svg{margin-right:", hasIconOnly ? 0 : rem(8), ";height:auto;max-height:100%;path{fill:currentColor;transition:fill 0.2s ease;}}" + (process.env.NODE_ENV === "production" ? "" : ";label:svgStyles;"));
};
var variantStyles = function variantStyles(_ref12) {
  var _variantColor$color, _variantColor$color2;
  var disabled = _ref12.disabled,
    isInverse = _ref12.isInverse,
    variant = _ref12.variant,
    isPrimary = _ref12.isPrimary,
    isHollow = _ref12.isHollow;
  if (disabled || isHollow) {
    return;
  }
  if (variant === 'phony') {
    return /*#__PURE__*/css("all:unset;background:none;color:", colors.blue_500, ";cursor:pointer;display:inline-block;font-size:inherit;font-weight:", typography.typographyFontWeightBold, ";height:auto;line-height:inherit;margin:0;min-height:0;min-width:0;outline:0;padding:0;text-align:left;border-radius:0;&:hover{background:", colors.lightBlue_100, ";color:", colors.blue_500, ";text-decoration:none;}&:focus{box-shadow:", rem(0, 0, 0, 3), " ", colors.lightBlue_500, ";outline:none;text-decoration:none;}", isInverse && /*#__PURE__*/css("color:", colors.lightBlue_500, ";&:hover{background:", colors.blue_500, ";color:", colors.lightBlue_500, ";}&:active{color:", colors.white, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:variantStyles;")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:variantStyles;"));
  }
  var variantColors = {
    caution: {
      background: {
        primary: colors.yellow_500,
        secondary: colors.yellow_500
      },
      color: {
        hover: colors.yellow_700
      },
      shadow: colors.yellow_500
    },
    community: {
      background: {
        primary: colors.coral_500,
        secondary: colors.coral_100
      },
      color: {
        hover: colors.coral_700
      },
      shadow: colors.coral_500
    },
    critical: {
      background: {
        primary: colors.red_500,
        secondary: colors.red_500
      },
      color: {
        "default": colors.white,
        hover: colors.red_700
      },
      shadow: colors.red_500
    },
    information: {
      background: {
        primary: colors.lightBlue_500,
        secondary: colors.lightBlue_100
      },
      color: {
        hover: colors.blue_500
      },
      shadow: colors.lightBlue_500
    },
    muted: {
      background: {
        primary: colors.coolGray_200,
        secondary: colors.white
      },
      color: {
        hover: colors.navy_500
      },
      shadow: colors.coolGray_200
    },
    protection: {
      background: {
        primary: colors.purple_300,
        secondary: colors.purple_100
      },
      color: {
        hover: colors.purple_700
      },
      shadow: colors.purple_500
    },
    success: {
      background: {
        primary: colors.green_500,
        secondary: colors.green_100
      },
      color: {
        hover: colors.green_700
      },
      shadow: colors.green_500
    }
  };
  var variantColor = variantColors[variant] || variantColors.information;
  return /*#__PURE__*/css("background:", variantColor.background.primary, ";color:", ((_variantColor$color = variantColor.color) === null || _variantColor$color === void 0 ? void 0 : _variantColor$color["default"]) || colors.navy_500, ";&:hover{box-shadow:", rem(0, 0, 0, 2), " ", variantColor.shadow, ";}&:focus{box-shadow:", rem(0, 0, 0, 4), " ", colors.white, ",", rem(0, 0, 0, 8), " ", colors.lightBlue_500, ",inset ", rem(0, 0, 0, 2), " ", variantColor.shadow, ";}&:hover,&:focus{background:", colors.white, ";color:", (_variantColor$color2 = variantColor.color) === null || _variantColor$color2 === void 0 ? void 0 : _variantColor$color2.hover, ";}&:active{background:", variantColor.background.primary, ";box-shadow:inset ", rem(0, 4, 4, 0), " ", rgba(colors.blackDeep, 0.2), ";color:", colors.navy_500, ";}", variant === 'muted' && /*#__PURE__*/css("border:", rem(1), " solid ", colors.coolGray_600, ";&:hover{box-shadow:none;}&:focus{border-color:", colors.transparent, ";box-shadow:", rem(0, 0, 0, 4), " ", colors.white, ",", rem(0, 0, 0, 8), " ", colors.lightBlue_500, ",inset ", rem(0, 0, 0, 2), " ", colors.coolGray_500, ";}&:active{background:", variantColor.background.primary, ";border-color:", colors.coolGray_600, ";box-shadow:inset ", rem(0, 4, 4, 0), " ", rgba(colors.blackDeep, 0.2), ";color:", colors.navy_500, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:variantStyles;")), " ", !isPrimary && /*#__PURE__*/css("background:", variantColor.background.secondary, ";", variant === 'muted' && /*#__PURE__*/css("border:", rem(1), " solid ", colors.coolGray_500, ";&:hover{background:", colors.coolGray_300, ";}&:active{background:", colors.white, ";border-color:", colors.coolGray_500, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:variantStyles;")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:variantStyles;")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:variantStyles;"));
};
var isHollowStyles = function isHollowStyles(_ref13) {
  var isInverse = _ref13.isInverse,
    isPrimary = _ref13.isPrimary,
    isHollow = _ref13.isHollow,
    disabled = _ref13.disabled;
  if (isHollow && !disabled) {
    return /*#__PURE__*/css("background:", colors.transparent, ";color:", isInverse ? colors.lightBlue_500 : colors.navy_500, ";font-weight:", typography.typographyFontWeightSemiBold, ";&:hover{background:", !isPrimary && colors.white || isInverse && colors.blue_500 || colors.lightBlue_100, ";}&:focus{box-shadow:", rem(0, 0, 0, 4), " ", colors.lightBlue_500, ";}&:active{background:", colors.transparent, ";box-shadow:inset ", rem(0, 4, 4, 0), " ", rgba(colors.blackDeep, 0.2), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:isHollowStyles;"));
  }
};

/** Export to use as selector in other component's styles. */
var resetStyles = getResetByTag('button');
var StyledButton = /*#__PURE__*/_styled('button', process.env.NODE_ENV === "production" ? {
  target: "e14c8aa40"
} : {
  target: "e14c8aa40",
  label: "StyledButton"
})(resetStyles, defaultStyles, blockStyles, disabledStyles, loaderStyles, shapeStyles, sizeStyles, isCondensedStyles, hasIconOnlyStyles, svgStyles, variantStyles, isHollowStyles, utilityStyles);
export default StyledButton;